export const FIND_ORDER = 'find-order';
export const GET_ORDER_SUMMARY = 'order-summary';
export const GET_SHOPPER_ORDER_DETAILS = 'order-details';
export const GET_ANONYMOUS_ORDER_DETAILS = 'anonymous-order-details';
export const GET_PAYMENT_DETAILS = 'payment-details';
export const GET_BUY_IT_AGAIN = 'buy-it-again';
export const GET_ORDER_FEEDBACK_GROUPS = 'order-feedback-groups';
export const GET_ANONYMOUS_ORDER_FEEDBACK_GROUPS =
  'anonymous-order-feedback-groups';
export const GET_FEEDBACK_GROUP = 'feedback-group';
export const GET_ANONYMOUS_FEEDBACK_GROUP = 'anonymous-feedback-group';
export const GET_SMS_SUBSCRIPTION = 'sms-subscription';
